import PRC from "components/Stacker/constants/ProductConfiguratorConstants"
import PRConfig from "components/Stacker/config/ProductConfiguratorConfig"

export const initialState = {
  currentStep: 1,
  metal: "",
  design: "" || PRConfig.DESIGN_VALUES[0],
  font: "deco",
  fontCode: "DEC",
  text: "",
  icon: "",
  motifCode: "",
  theme: "",
  dataset: [],
  configTypeValue: "",
}

export const getNextStep = (state) => {
  const { theme, currentStep } = state
  let step
  if (theme === "men" && currentStep === 1) {
    step = currentStep + 2
  } else {
    step = currentStep + 1
  }
  return step
}

export const getPrevStep = (state) => {
  const { theme, currentStep } = state
  switch (currentStep) {
    case 1:
      return "exit"
    default: {
      let step
      if (theme === "men" && currentStep === 3) {
        step = currentStep - 2
      } else {
        step = currentStep - 1
      }
      return step
    }
  }
}

export default function ProductConfiguratorReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case PRC.PRODUCT_CONFIG_SET_CONFIG_DATA:
      return {
        ...state,
        dataset: action.payload.data,
        configTypeValue: action.payload.configTypeValue,
      }
    case PRC.PRODUCT_CONFIG_GET_SELECTED:
      return action.payload
    case PRC.PRODUCT_CONFIG_NEXT_STEP:
      return { ...state, currentStep: getNextStep(state) }
    case PRC.PRODUCT_CONFIG_PREV_STEP:
      return { ...state, currentStep: getPrevStep(state) }
    case PRC.PRODUCT_CONFIG_SET_METAL:
      return { ...state, metal: action.payload.metal }
    case PRC.PRODUCT_CONFIG_SET_DESIGN:
      return { ...state, design: action.payload.design }
    case PRC.PRODUCT_CONFIG_SET_CUSTOM:
      return {
        ...state,
        font: action.payload.font,
        fontCode: action.payload.fontCode,
        text: action.payload.text,
      }
    case PRC.PRODUCT_CONFIG_SET_MOTIF:
      return {
        ...state,
        icon: action.payload.icon,
        motifCode: action.payload.motifCode,
      }
    case PRC.PRODUCT_CONFIG_SET_THEME:
      return { ...state, theme: action.payload }
    case PRC.PRODUCT_CONFIG_RESET:
      return initialState
    default:
      return state
  }
}
